import { print } from 'graphql';

import { graphql } from '@eluve/graphql-fhir';

/**
 * FHIR GraphQL query that mirrors what `useMedplumPatientAccess` needs —
 * finding the patient by Eluve identifier, and (when visible) pulling the
 * current general practitioners in a single round-trip.
 *
 * Lives with the Medplum infra (not a feature lib) because the access hook
 * and the profile pages both consume it.
 *
 * The tenant-member AccessPolicy scopes this to
 * `Patient?general-practitioner=%profile` server-side, so if the current
 * profile is not a GP for the patient, `PatientList` returns an empty array.
 * The client cannot distinguish "policy filtered" from "patient not synced"
 * — both look like an empty list here.
 */
export const PATIENT_BY_IDENTIFIER_QUERY = graphql(`
  query FhirPatientByIdentifier($identifier: String!) {
    PatientList(identifier: $identifier, _count: 1) {
      id
      identifier {
        system
        value
      }
      generalPractitioner {
        reference
        resource {
          ... on Practitioner {
            id
            name {
              given
              family
            }
            telecom {
              system
              value
            }
          }
        }
      }
    }
  }
`);

/** Printed form of the query, rendered in the access-debugging UI. */
export const PATIENT_BY_IDENTIFIER_QUERY_SOURCE = print(
  PATIENT_BY_IDENTIFIER_QUERY,
);
